<template>
    <div class="frb frb-info" v-if="isActive">
        <input ref="radio_method" autocomplete="off" type="radio" :id="input_id" name="radio-button" @click="select" :checked="methodSelected"
               value="pagseguro" />
        <label :for="input_id">
            <div class="card-body">
                <div class="pix">
                  <ul class="list-unstyled list-inline">
                    <li class="list-inline-item">
                      <img src="../../../../static/templates/img/loghi_pagamenti/Pix_logo.png" class="img-responsive inline-block checkoutcardfirst" alt="pix" height="30" />
                    </li>
                  </ul>
                </div>
              <p class="small mb-1 mt-2" v-if="showInvoiceFormLink">
                    <a href="#" @click.stop.prevent="onShowInvoiceForm">
                        {{ $parent.wantReceiveInvoiceMessage }}
                    </a>
            </p>
            </div>
        </label>
    </div>
</template>

<script>
    // import Translations from "./insert-me-to-translate.vue";

    import { mapGetters } from "vuex";
    import paymentMethodMixin from "./mixins/payment-method-mixin";
    export default {
        mixins: [paymentMethodMixin],
        name: "pix",
        data: function () {
          return {
            'qrcode_div': null
          }
        },
        props: ['methodPrefix'],
        computed: {
          input_id: function (){
            return `${this.methodPrefix}-radio-button-pix`
          },
          ...mapGetters({
            captchaResponse: "ui/recaptcha/response",
            getCaptchaComponent: "ui/recaptcha/getCaptchaComponent"
          })
        },
        methods: {
            pay: function (event) {
              if (this.qrcode_div) {
                  this.$store.dispatch("ui/lightbox/show", {
                    html: this.qrcode_div
                  });
              } else {
                this.$store.dispatch("ui/loader/show");
                const data = {
                    'orderId': this.order.orderId,
                    'userId': this.order.userId,
                }
                if (this.captchaResponse !== null) {
                    data['h-captcha-response'] = this.captchaResponse;
                    data['NEW_CAPTCHA_SITE_KEY'] = this.getCaptchaComponent.sitekey;
                } 
                $http({
                  method: 'post',
                  headers: {
                    'X-CSRFToken': this.$cookies.get('csrftoken'),
                  },
                  url: this.proxyUrl,
                  data: data
                }).then((response) => {
                  if (response.status === 200) {
                      if (response.data.success === "OK") {
                        const invoiceId = response.data.data;
                        document.location = `${this.proxyUrl}${invoiceId}/`;
                      } else {
                          this.$store.dispatch("ui/lightbox/show", {
                              title: gettext("Payment error"),
                              body: response.data.error_message || gettext("System error. Please try again later"),
                          })
                          this.$store.dispatch("ui/loader/hide");
                      }
                  } else {
                      console.error(response);
                  }
                }).catch((error) => {
                  console.log(error)
                  this.show_errors()
                  this.$store.dispatch("ui/loader/hide");
                });
              }

            }
        }
    }
</script>
